
export const GET_EMPLOYEE_INFORMATION = "GET_EMPLOYEE_INFORMATION";


export const ACCOUNT_ENTRIES_COMPANIES = "ACCOUNT_ENTRIES_COMPANIES";


export const ACCOUNT_ENTRIES_GET_DOCUMENT_RESOURCES = "ACCOUNT_ENTRIES_GET_DOCUMENT_RESOURCES";
export const ACCOUNT_ENTRIES_GET_DOCUMENT_DATA = "ACCOUNT_ENTRIES_GET_DOCUMENT_DATA";
export const ACCOUNT_ENTRIES_GET_ACTIVE_GROUP = "ACCOUNT_ENTRIES_GET_ACTIVE_GROUP";
export const ACCOUNT_ENTRIES_SAVE_NEW_GROUP = "ACCOUNT_ENTRIES_SAVE_NEW_GROUP";
export const ACCOUNT_ENTRIES_SET_DEFAULT_GROUP = "ACCOUNT_ENTRIES_SET_DEFAULT_GROUP";
export const ACCOUNT_ENTRIES_LIST_GROUPS = "ACCOUNT_ENTRIES_LIST_GROUPS";
export const ACCOUNT_ENTRIES_GET_GROUP_DETAILS = "ACCOUNT_ENTRIES_GET_GROUP_DETAILS";

export const ACCOUNT_ENTRIES_SET_NEW_GROUP = "ACCOUNT_ENTRIES_SET_NEW_GROUP";
export const ACCOUNT_ENTRIES_GROUP_UPDATE = "ACCOUNT_ENTRIES_GROUP_UPDATE";
export const ACCOUNT_ENTRIES_GROUP_SAVE = "ACCOUNT_ENTRIES_GROUP_SAVE";
export const ACCOUNT_ENTRIES_GROUP_DELETE = "ACCOUNT_ENTRIES_GROUP_DELETE";


export const ACCOUNT_ENTRIES_SCHEME = "ACCOUNT_ENTRIES_SCHEME";
export const ACCOUNT_ENTRIES_PERIODS = "ACCOUNT_ENTRIES_PERIODS";
export const ACCOUNT_ENTRIES_VFLEX_CONFIGURATION = "ACCOUNT_ENTRIES_VFLEX_CONFIGURATION";

export const VFLEX_SAVE_FIELD_POSITION = "VFLEX_SAVE_FIELD_POSITION";
export const VFLEX_SAVE_FIELD_WIDTH = "VFLEX_SAVE_FIELD_WIDTH";
export const VFLEX_SAVE_FIELDS_CONFIG = "VFLEX_SAVE_FIELDS_CONFIG";
export const VFLEX_SAVE_FIELDS_GROUPING = "VFLEX_SAVE_FIELDS_GROUPING";